import * as React from "react";
import { useState } from "react";
import { RootState } from "../../reducers/index";
import { useAppDispatch, useAppSelector } from "../../store/index";
import {
    PaymentElement,
    useElements,
    useStripe,
} from "@stripe/react-stripe-js";

interface CheckoutPaymentStripeProps {
    receiptUrl: string;
}

const CheckoutPaymentStripe = ({ receiptUrl }: CheckoutPaymentStripeProps) => {
    //const { items, description } = useAppSelector((state: RootState) => state.cart);
    //const { providerId, clientId } = useAppSelector((state: RootState) => state.checkout);
    const dispatch = useAppDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const [message, setMessage] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js hasn't yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: receiptUrl,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message ?? "stripe error");
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    const paymentElementOptions = {
        layout: "tabs" as const,
        paymentMethodOrder: ["card"]
    };

    return (
        <>
            <form id="payment-form" onSubmit={handleSubmit}>
                <PaymentElement
                    id="payment-element"
                    options={paymentElementOptions}
                />
                <div className="mt-3">
                    <button
                        disabled={isLoading || !stripe || !elements}
                        id="submit"
                        className="btn btn-primary"
                    >
                        <span id="button-text">
                            {isLoading
                                ? <div className="spinner" id="spinner"></div>
                                : "Pay now"}
                        </span>
                    </button>
                    {/* Show any error or success messages */}
                    {message && (
                        <div className="alert-text" id="payment-message">
                            {message}
                        </div>
                    )}
                </div>
            </form>
        </>
    );
};

export default CheckoutPaymentStripe;
